





















import store from '@/store'
import ApiClient from '@/js/api.js'
import ManageBase from '@/views/organisms/ManageBase.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import CartPankuzu from '@/views/molecules/CartPankuzu.vue'
import BackButton from '@/views/atoms/BackButton.vue'

export default
  name: 'RegiEnd'

  components: {
    ManageBase
    ManageTemplate
    Pankuzu
    Title
    CartPankuzu
    BackButton
  }
  data: {
    result: 0
  }
  created: () ->
    store.dispatch('initPostParam')
    @$emit('set_color', true)
    wk = location.search.replace('?', '')
    params = wk.split('&')
    orderID = ''
    for param in params
      if param.indexOf('result=') == 0
        wks = param.split('=')
        @result = wks[1]
      if param.indexOf('user_id=') == 0
        wks = param.split('=')
        orderID = wks[1]
    if @result == '1'
      api = new ApiClient()
      param =
        order: decodeURIComponent(orderID)
      data = await api.post('/member/purchase/update', true, param)
      ga('require', 'ecommerce')
      ga('ecommerce:addTransaction',
        'id': data.id
      )
      for item in data.items
        ga('ecommerce:addItem', 
          'id': item.item_id
          'name': item.item_name
          'category': item.store_name
          'price': item.price
          'quantity': item.count
        )
      ga('ecommerce:send')
  methods: {
      go_top: (e) ->
        @$router.push '/'
  }
